module.exports = __webpack_public_path__ + "static/img/PVC Film_tape sheet_deskstop.9f005496.jpg";